import { render } from "./Honor.vue?vue&type=template&id=501ed7eb"
import script from "./Honor.vue?vue&type=script&lang=js"
export * from "./Honor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__